import { render, staticRenderFns } from "./DebtCard.vue?vue&type=template&id=cda18526&"
import script from "./DebtCard.vue?vue&type=script&lang=js&"
export * from "./DebtCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports